// AssistantFlyCallDeck — SLIDES on a call's theater (a Presentation ask in the
// call: meet functions/meetFly.js kind 'deck'; docs/FLY_MODE.md §3.3). Nika
// 2026-10-18: "main mode is theater in different modes". The deck view's own
// parts — the title, ONE slide on the stage (AssistantDeckSlide: its live
// cards read under this member's grants), Previous · 3 / 6 · Next — on the
// layer's sheet. The asker presents: their move goes to everyone; anyone else
// peeks for themselves until the asker moves again. State = the model
// functions/assistantFlyCall.js assistantFlyCallDeck derives.
export const AssistantFlyCallDeck = {
  tag: 'section',
  dataFlyCallDeck: true,
  dataStatus: (el, s) => (s && s.status) || 'loading',
  ariaBusy: (el, s) => (s && (s.status === 'loading' || s.status === 'streaming') ? 'true' : null),
  flow: 'y',
  gap: 'B',
  minWidth: '0',
  width: '100%',
  boxSizing: 'border-box',

  DeckTitle: {
    tag: 'h2',
    dataDeckTitle: true,
    margin: '0',
    fontSize: 'C',
    fontWeight: '700',
    lineHeight: '1.2',
    color: 'title',
    minWidth: '0',
    overflowWrap: 'anywhere',
    hide: (el, s) => !s || !s.title,
    text: (el, s) => (s && s.title) || ''
  },

  // A failure's one sentence (the deck's own words).
  DeckStatus: {
    tag: 'p',
    margin: '0',
    fontSize: 'Z',
    color: 'caption',
    hide: (el, s) => !s || !s.statusText,
    text: (el, s) => (s && s.statusText) || ''
  },

  // The stage: the ONE slide on screen, keyed by the slide (a new slide is a
  // new element); a skeleton slide while nothing has landed.
  DeckStage: {
    dataDeckStage: true,
    ariaLive: 'polite',
    minWidth: '0',
    childrenAs: 'state',
    children: (el, s) => (s && s.slide ? [s.slide] : []),
    childExtends: 'AssistantDeckSlide'
  },

  // Previous · 3 / 6 · Next — under the stage, centred.
  DeckNav: {
    dataDeckNav: true,
    flow: 'x',
    align: 'center center',
    gap: 'Z',
    minWidth: '0',
    hide: (el, s) => !s || (Number(s.count) || 0) < 2,
    AppCapsuleBtnToolbar_prev: {
      compact: true,
      dataDeckPrev: true,
      disabled: (el, s) => (s && s.canPrev ? null : true),
      text: '{{ workspace.assistantDeck.previous | polyglot }}',
      onClick: (e, el, s) => el.call('assistantFlyCallDo', 'meetFlyDeckGo', -1, s && s.key)
    },
    DeckCounter: {
      tag: 'span',
      dataDeckCounter: true,
      fontSize: 'Z',
      fontWeight: '500',
      color: 'caption',
      fontVariantNumeric: 'tabular-nums',
      text: (el, s) => (s && s.counter) || ''
    },
    AppCapsuleBtnToolbar_next: {
      compact: true,
      dataDeckNext: true,
      disabled: (el, s) => (s && s.canNext ? null : true),
      text: '{{ workspace.assistantDeck.next | polyglot }}',
      onClick: (e, el, s) => el.call('assistantFlyCallDo', 'meetFlyDeckGo', 1, s && s.key)
    }
  }
}
